/* eslint import/prefer-default-export: "off" */
import * as React from 'react'
import * as styles from '../expander.policies.styl'

export interface DisplayPolicy {
  id?: string
  title?: string
}
export interface PolicyProps {
  attr?: React.HtmlHTMLAttributes<HTMLDivElement> & {
    'data-index'?: string
  }
  item: DisplayPolicy
  identity_uri: string
  onClick: (item: string, identity_uri: string) => void
}

export const Policy: React.FC<PolicyProps> = ({
  attr,
  item,
  identity_uri,
  onClick
}: PolicyProps) => (
  <p
    {...attr}
    className={styles.link}
    onClick={() => onClick(item.id, identity_uri)}
  >
    {item.title}
  </p>
)
